import { SliderDesignTokens } from '@primeuix/themes/aura/slider';

export const sliderTokens: SliderDesignTokens = {
  root: {
    transitionDuration: '{transition.duration}',
  },
  track: {
    background: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    size: '3px',
  },
  range: {
    background: '{primary.color}',
  },
  handle: {
    width: '20px',
    height: '20px',
    borderRadius: '{slider.handle.width} / 2',
    background: '{content.border.color}',
    hoverBackground: '{content.border.color}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    content: {
      width: '16px',
      height: '16px',
      borderRadius: '{slider.handle.content.width} / 2',
      hoverBackground: '{content.background}',
      shadow: '0 0.5px 0 0 rgba(0, 0, 0, 0.08), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
    },
  },
  colorScheme: {
    light: {
      handle: {
        content: {
          background: '{surface.0}',
        },
      },
    },
    dark: {
      handle: {
        content: {
          background: '{primary.contrast.color}',
        },
      },
    },
  },
};
